import Projects from './ProjectsContainer';

export default Projects;
